/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useMediaQuery } from '@material-ui/core';

export function useScreenSize() {
  const isSmallOrBigger = useMediaQuery(theme => theme?.breakpoints.up('sm'));
  const isMediumOrBigger = useMediaQuery(theme => theme?.breakpoints.up('md'));
  const isLargeOrBigger = useMediaQuery(theme => theme?.breakpoints.up('lg'));
  const isExtraLargeOrBigger = useMediaQuery(theme => theme?.breakpoints.up('xl2'));

  return {
    isSmallOrBigger,
    isMediumOrBigger,
    isLargeOrBigger,
    isExtraLargeOrBigger,
  };
}
